import React, { useState } from 'react'
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { PRODUCT_LIVE_URL } from '../../utils/Constant';

const ProductLive = ({ newProductId, productDetails  }) => {
    const [productIsLive, setProductIsLive] = useState(false);
    const authToken = useSelector((state) => state.token);

    const showToast = (loading, message, type, errors) => {
        let errorMessage = "";

        if (errors && errors.length > 0) {
            errorMessage = (
                <ul>
                    {errors.map((error, index) => (
                        <li key={index}>{error.msg}</li>
                    ))}
                </ul>
            );
        }
        toast[type](
            <div>
                {loading} {message} {errorMessage}
            </div>,
            {
                position: toast.POSITION.TOP_CENTER,
                autoClose: 3000, // milliseconds
            }
        );
    };

    const handleIsLive = async (e) => {
        e.preventDefault();
        try {
            showToast(true, "In Progress. Please wait..", "info");
            const response = await fetch(`${PRODUCT_LIVE_URL}/${newProductId}`,
                {
                    method: "POST",
                    headers: {
                        Authorization: `Bearer ${authToken.token}`,
                    },
                }
            );
            const data = await response.json();
            if (response.ok) {
                showToast(true, data.msg, "success");
                setProductIsLive(true)
            } else {
                showToast(true, "An error occurred.", "error", data.errors);
            }
        } catch (error) {
            showToast(true, "Test :  " + error.message, "error");
            console.error(error.message, error);
        }
    }
    return (
        <div
            style={{
                display: "flex",
                "justifyContent": "space-between",
            }}
        >
            {newProductId && !productDetails?.isLive && !productIsLive ?
                <a onClick={handleIsLive} className="btn btn-primary">
                    Make it Live
                </a> : ""}


            {/* <a href="/" className="btn btn-info">
                Relist Now
            </a> */}

            {/* <a href="/" className="btn btn-danger">
                End Now
            </a> */}
        </div>
    )
}

export default ProductLive